import styled from 'styled-components';

import { Colour, MinBreakpointV2 } from '@xemplo/style-constants';

export const FooterContainer = styled.footer`
  position: sticky;
  bottom: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  gap: 12px;
  padding: 20px 16px 24px 16px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  .extra {
    order: 1;
    grid-row: 1;
    grid-column: 1 / span 2;
  }

  .primary-button {
    order: 3;
  }
  .secondary-button {
    order: 2;
  }

  .tertiary-button {
    order: 4;
    grid-column: 1 / span 2;
    text-align: center;
    padding: 0;
  }

  &.hasPrimaryOrSecondary {
    grid-template-columns: 1fr;
  }

  &.showKeyline {
    border-top: 1px solid ${Colour.Gray[200]};
  }

  @media ${MinBreakpointV2.medium} {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 24px 40px 32px 40px;
    .tertiary-button {
      margin-right: auto;
      order: 1;
    }
    .secondary-button {
      min-width: 120px;
    }
    .primary-button {
      min-width: 120px;
    }
  }
`;
